import jwtDecode from "jwt-decode";

const validateExpireAccessToken = (accessToken) => {
  if (accessToken === null || accessToken === "undefined" || accessToken === "")
    return false;

  if (accessToken !== null || accessToken !== "") {
    const decoded = jwtDecode(accessToken);
    const exp = decoded.exp;

    if (Date.now() >= exp * 1000) {
      return false;
    }
  }

  return true;
};

export const getUserInfo = (accessToken) => {
  if (accessToken === null || accessToken === "undefined" || accessToken === "")
    return false;
  else {
    const decoded = jwtDecode(accessToken);
    return decoded;
  }
};

export { validateExpireAccessToken };
